module.exports = __webpack_public_path__ + "static/img/02.39e41a1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/mobile/02.png
// module id = hcnj
// module chunks = 1